import { Card, CardContent } from "@/components/ui/card";

export default function ReviewsSkeletonCard() {
  return (
    <Card className="h-full shadow-sm rounded-2xl">
      <CardContent className="p-5 space-y-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-muted animate-pulse flex-shrink-0" />
          <div className="space-y-1.5 flex-1">
            <div className="h-3.5 w-28 rounded bg-muted animate-pulse" />
            <div className="h-3 w-16 rounded bg-muted animate-pulse" />
          </div>
        </div>
        <div className="space-y-2 pt-1">
          <div className="h-3 w-full rounded bg-muted animate-pulse" />
          <div className="h-3 w-full rounded bg-muted animate-pulse" />
          <div className="h-3 w-4/5 rounded bg-muted animate-pulse" />
          <div className="h-3 w-3/5 rounded bg-muted animate-pulse" />
        </div>
        <div className="h-3 w-20 rounded bg-muted animate-pulse mt-2" />
      </CardContent>
    </Card>
  );
}
